export enum ScriptingLanguage {
    Bash = "Bash",
    CSharp = "CSharp",
    FSharp= "FSharp",
    PowerShell = "PowerShell"
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/scriptingLanguage.ts